const krajRejestracji = { t: 'Kraj rejestracji', name: 'kraj-rejestracji', hint: { url: '/country' }}
export default krajRejestracji